import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TransactionListState,
  TRANSACTION_LIST_STATE,
} from './transaction-list.state';

export const selectTransaction = createFeatureSelector<TransactionListState>(
  TRANSACTION_LIST_STATE
);

export const selectTransactionList = createSelector(
  selectTransaction,
  (state: TransactionListState) => {
    return state.dataSource;
  }
);

export const selectTransactionListFilter = createSelector(
  selectTransaction,
  (state: TransactionListState) => state.filter
);
